export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Repartidor',
	plural_model_name_spanish: 'Repartidores',
	create_model_name_spanish: 'Nuevo Repartidor',
	text_delete: 'el',
}